export const GET_INSURERS = "GET_INSURERS";
export const GET_INSURER = "GET_INSURER";
export const UPDATE_INSURERS = "UPDATE_INSURERS";
export const SELECT_INSURER = "SELECT_INSURER";
export const REMOVE_INSURER = "REMOVE_INSURER";
export const UPDATE_INSURER_OFFERS = "UPDATE_INSURER_OFFERS";
export const UPDATE_INSURER_TREATIES = "UPDATE_INSURER_TREATIES";
export const CHANGE_INSURER_PAGE_TYPE = "CHANGE_INSURER_PAGE_TYPE";